import Service from '../Service'
import {http} from '../config'

export default class BeneficiarioAvaliacaoService extends Service{
    constructor(){
        super('BeneficiarioAvaliacao');
    }

    BuscarBeneficiario(q){
        return http.get(`${this.getNomeControle()}/BuscarBeneficiario`, {
            params: { q }
        });
    }

    ResumoBeneficiario(beneficiarioId){
        return http.get(`${this.getNomeControle()}/ResumoBeneficiario`, {
            params: { beneficiarioId }
        });
    }

    TimelineResumo(filter){
        return http.get(`${this.getNomeControle()}/TimelineResumo`, { params: filter });
    }

    TimelineBeneficiarios(filter){
        return http.get(`${this.getNomeControle()}/TimelineBeneficiarios`, { params: filter });
    }

    TimelineAvaliacoes(filter){
        return http.get(`${this.getNomeControle()}/TimelineAvaliacoes`, { params: filter });
    }

    TimelineItens(avaliacaoId){
        return http.get(`${this.getNomeControle()}/${avaliacaoId}/TimelineItens`);
    }

    Relatorio(filter){
        return http.get(`${this.getNomeControle()}/Relatorio`, {
            params: filter
        });
    }

    Historico(avaliacaoId){
        return http.get(`${this.getNomeControle()}/${avaliacaoId}/Historico`);
    }
}
